import * as React from "react";
import { AddToCart } from "@grandvisionhq/carts-v2";
import { useIntl } from "@grandvisionhq/state";
import { ProductRecommendationAction } from "../../../../../../../../../../lib-components/RecommendedProducts/types.js";
import { ProductBlockActionSuccessText } from "../../../../../../../ProductBlockActionSuccessText/lib-components/RecommendedProducts/components/ProductRecommendationBlock/components/ProductBlockActionSuccessText/ProductBlockActionSuccessText.js";
/* empty css                        */
const ProductBlockAction = ({
  productType,
  activeSku,
  action,
  onAddProduct,
  tabIndex
}) => {
  const { getLabel } = useIntl();
  const [quantity, setQuantity] = React.useState(1);
  const [productAddedToCart, setProductAddedToCart] = React.useState(false);
  const itemDraft = {
    sku: activeSku,
    quantity,
    type: "regular"
  };
  const addProduct = () => {
    setProductAddedToCart(true);
    onAddProduct && onAddProduct();
  };
  if (!action || action === ProductRecommendationAction.Redirect) return null;
  if (productAddedToCart) {
    return /* @__PURE__ */ React.createElement(ProductBlockActionSuccessText, null);
  }
  return /* @__PURE__ */ React.createElement("div", { className: "product-block-action" }, /* @__PURE__ */ React.createElement(
    AddToCart,
    {
      onSuccess: addProduct,
      variant: "ghost",
      caption: getLabel("cart.actions.addToCart"),
      lineItemDrafts: [itemDraft],
      handleQuantityUpdate: setQuantity,
      quantity,
      isQuantitySelectorEnabled: action === "addQuantity",
      productType,
      tabIndex
    }
  ));
};
export {
  ProductBlockAction
};
//# sourceMappingURL=ProductBlockAction.js.map
